import {
  ImageScaleView,
  LinearAddFilter,
  View,
} from '@play-co/timestep-core/ui';
import { gsap } from 'gsap';

export default class ShineFx extends View {
  private shines: ImageScaleView[] = [];
  private opacity: number;

  constructor({
    superview,
    scale = 1,
    opacity = 1,
  }: {
    superview: View;
    scale?: number;
    opacity?: number;
  }) {
    super({
      superview,
      centerOnOrigin: true,
      centerAnchor: true,
      scale,
    });

    this.opacity = opacity;

    const opts = {
      superview: this,
      image: 'assets/ui/match2/common/fx_shine.png',
      width: 458,
      height: 376,
      centerOnOrigin: true,
      centerAnchor: true,
      filter: new LinearAddFilter('rgba(255, 255, 255, 0.5)'),
      opacity: 0.5,
    };

    this.shines.push(new ImageScaleView(opts), new ImageScaleView(opts));

    this.style.opacity = 0;
  }

  public override async show() {
    super.show();
    gsap.to(this.style, {
      duration: 1,
      opacity: this.opacity,
      ease: 'none',
    });

    this.shines.forEach((shine, i) => {
      gsap.to(shine.style, {
        duration: i === 0 ? 10 : 13,
        r: Math.PI * 2 * (i === 0 ? 1 : -1),
        ease: 'none',
        repeat: -1,
      });
    });
  }

  public override async hide() {
    this.shines.forEach((shine) => gsap.killTweensOf(shine.style));
    super.hide();
  }
}
